// Serialized JSON length of the configuration. A real rule is a few kilobytes; the cap keeps a hostile
// snapshot from inflating the prompt.
export const ASSISTANT_AUTOMATION_RULE_ON_SCREEN_MAX_CHARACTERS = 16_000;
